export default {
  invoices: [],
  selectedInvoice: {},
  invoicesCount: 0
}
